import Logo from '@@/auto/components/Logo';
import Text from '@@/auto/components/Text';

import classes from './ToyotaHero.module.css';

export interface IStandardHero {
  title1: string;
  title2: string;
}

const testId = {
  one: 'signUpView_heroTitle1',
  two: 'signUpView_heroTitle2',
};

export default function ToyotaHero({ title1, title2 }: IStandardHero) {
  return (
    <div className={classes.root}>
      <Logo
        overrideClasses={{ root: classes.logo }}
        data-testid="tenant_logo"
      />
      <div className={classes.vertical_spacing}>
        <Text
          variant="h2"
          component="h1"
          data-testid={testId.one}
          className={classes.h1}
        >
          {title1}
        </Text>
        <Text variant="h4" component="h2" data-testid={testId.two}>
          {title2}
        </Text>
      </div>
    </div>
  );
}
